type SectionProps = {
  title: string;
  icon: React.ReactNode;
  children: React.ReactNode;
  gradient: string;
};

// Components
export const Section: React.FC<SectionProps> = ({ title, icon, children, gradient }) => (
  <div className="relative overflow-hidden bg-white rounded-2xl shadow-lg border border-gray-100 mb-6 transition-all duration-300 hover:shadow-xl">
    <div className={`absolute top-0 left-0 right-0 h-1 bg-gradient-to-r ${gradient}`}></div>
    <div className="px-8 py-6">
      <div className="flex items-center space-x-3 mb-6">
        <div className={`p-3 rounded-xl bg-gradient-to-br ${gradient} bg-opacity-10`}>{icon}</div>
        <h3 className="text-xl font-bold text-gray-900">{title}</h3>
      </div>
      <div>{children}</div>
    </div>
  </div>
);
